import { render, staticRenderFns } from "./_dailyWinloseDetail.vue?vue&type=template&id=229a2fde&lang=pug&"
import script from "./_dailyWinloseDetail.vue?vue&type=script&lang=js&"
export * from "./_dailyWinloseDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports